
import { v4 as uuidv4 } from 'uuid'
export const getOrCreateUserId = () => {
  const KEY = 'user_uuid' // 本地存储的 key
  let userId = localStorage.getItem(KEY)

  // 如果不存在，则生成并存储
  if (!userId) {
    // 方法1: 使用浏览器原生 API（推荐，无需依赖库）
    userId = uuidv4()

    localStorage.setItem(KEY, userId) // 存储到本地
  }

  return userId
}
